module.exports = __webpack_public_path__ + "img/Jorge-Federico-Gras.3ad38560.jpg";